// SPDX-License-Identifier: Apache-2.0

import { jsonMember, jsonObject, TypedJSON } from "typedjson";
import PerunMessage from "./PerunMessage";
import PerunObject from "./PerunObject";
import CustomJSON from "./customjson";
import { MessageType, MessageTypeName } from "./messageTypes";

@jsonObject
export default class Request extends PerunMessage {
  @jsonMember(Number) id: number;
  @jsonMember(PerunObject) message: PerunObject;

  constructor(id: number, message: PerunObject) {
    super();
    this.id = id;
    this.message = message;
  }

  messageType(): MessageType {
    return Request;
  }

  messageTypeName(): MessageTypeName {
    return "Request";
  }

  static toJSON(me: Request) {
    return {
      type: me.messageTypeName(),
      id: me.id,
      message: JSON.parse(TypedJSON.stringify(me.message, PerunObject)),
    };
  }

  static fromJSON(js: any): Request {
    const reqMsg = TypedJSON.parse(js.message, PerunObject);

    if (reqMsg && js.id !== undefined) {
      return new Request(js.id, reqMsg);
    } else {
      throw new Error("could not parse request");
    }
  }
}

CustomJSON(Request);
